/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize SeroStatusHepatitisB List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './SeroStatusHepatitisBListView';

export const mapStateToPropsSeroStatusHepatitisBList = mapStateToProps;
export const mapDispatchToPropsSeroStatusHepatitisBList = mapDispatchToProps;

export default connect(
  mapStateToPropsSeroStatusHepatitisBList,
  mapDispatchToPropsSeroStatusHepatitisBList
)(View);
